import React, { useEffect, useState } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function BlogArtikel() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await axios.get(`${API}/blog/${slug}`);
        setPost(response.data);
        document.title = `${response.data.title} | Blog | RA Sindros`;
      } catch (err) {
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [slug]);

  if (loading) {
    return (
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20">
        <p className="text-sm" style={{ color: "#777" }}>Artikel wird geladen...</p>
      </div>
    );
  }

  if (notFound || !post) {
    return <Navigate to="/blog" replace />;
  }

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div>
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <Link
            to="/blog"
            className="text-sm font-medium mb-8 inline-block"
            style={{ color: "#2E75B6", transition: "opacity 0.2s ease" }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
          >
            Zurück zum Blog
          </Link>

          <time
            className="block text-xs font-medium tracking-wider uppercase mb-4"
            style={{ color: "#2E75B6" }}
          >
            {formatDate(post.date)}
          </time>

          <h1
            className="text-3xl lg:text-4xl font-bold mb-8 leading-tight"
            style={{
              color: "#1B3A5C",
              fontFamily: "'Source Serif 4', serif",
            }}
          >
            {post.title}
          </h1>

          {post.status === "draft" ? (
            <div
              className="rounded-lg p-8 border"
              style={{
                backgroundColor: "#F5F5F5",
                borderColor: "#E5E5E5",
              }}
            >
              <p className="text-base leading-relaxed" style={{ color: "#555555" }}>
                Dieser Artikel befindet sich derzeit in Vorbereitung und wird in
                Kürze veröffentlicht. Schauen Sie bald wieder vorbei.
              </p>
            </div>
          ) : (
            <div style={{ color: "#555555" }}>
              <p className="text-base leading-relaxed">{post.content}</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
